import { IPrescriptionRepository } from "../../adapters/driven/repositories/prescriptionRepository";

export type IPrescriptionService = ReturnType<
  typeof PrescriptionServiceImplFactory
>;

export const PrescriptionServiceImplFactory = ({
  prescriptionRepository,
}: {
  prescriptionRepository: IPrescriptionRepository;
}) => {
  const getPrescriptions = async (payload: {
    clinic_id: number;
    patient_id: number;
  }): IControllerPromiseResponse<IPrescription[]> => {
    try {
      const response = await prescriptionRepository.getPrescriptions(payload);
      return { success: true, data: response?.data ?? [] };
    } catch (error) {
      return { success: false, error };
    }
  };

  const getPrescriptionById = async (payload: {
    clinic_id: number;
    patient_id: number;
    prescription_id: number;
  }): IControllerPromiseResponse<IPrescription> => {
    try {
      const response = await prescriptionRepository.getPrescriptionById(
        payload
      );
      return { success: true, data: response?.data };
    } catch (error) {
      return { success: false, error };
    }
  };

  const uploadPrescription = async (
    payload: IUploadPrescriptionPayload
  ): IControllerPromiseResponse<IPrescription> => {
    try {
      const response = await prescriptionRepository.uploadPrescription(payload);
      return { success: true, data: response?.data };
    } catch (error) {
      return { success: false, error };
    }
  };

  const deletePrescription = async (payload: {
    clinic_id: number;
    patient_id: number;
    prescription_id: number;
  }): IControllerPromiseResponse<{ message: string }> => {
    try {
      const response = await prescriptionRepository.deletePrescription(payload);
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error };
    }
  };

  return {
    getPrescriptions,
    getPrescriptionById,
    uploadPrescription,
    deletePrescription,
  };
};
